namespace('compass.demographic');

compass.require('compass.hotel.RoomRequestsWidget');
compass.require('compass.hotel.RoomSharesWidget');
compass.require('compass.hotel.PoliciesWidget');

compass.require('compass.demographic.PersonalInfoWidget');
compass.require('compass.demographic.PasswordWidget');
compass.require('compass.demographic.DupeSelectWidget');
compass.require('compass.demographic.FrequentGuestNumberWidget');
compass.require('compass.demographic.PaymentWidget');
compass.require('compass.demographic.CreditCardWidget');
compass.require('compass.util.validate');

compass.requireLib('compass.util.parse');

compass.demographic.IndividualFormsWidget = compass.defineWidget(function IndividualFormsWidget(options) {
	var me = this;

	var d = jQuery.dom;
	var $j = jQuery;

	// handle the merge with the new defineView
	var _settings = options;
	var _ids = _settings.ids;
	var _validator;

	var _lastElementFocused = null;

	var _jsonData;
	var _invalid = false;

	var _personalInfoWidget, _passwordWidget, _roomRequestsWidget, _roomSharesWidget, _frequentGuestNumberWidget, _paymentWidget;

	var _form;

	var _drawTermsOfService = function(){
		if (_settings.meetingInfo.privacyPolicyLink.length === 0 ) return d.span({className: 'termsOfServiceText'}, '.');
		return [
				d.span({className: 'termsOfServiceText'}, ' and our '),
				d.a({className: 'termsOfServiceLink', 'href': _settings.meetingInfo.privacyPolicyLink, 'target': '_blank'}, 'terms of service.')
		];
	};

	
	this.render = function(widgetElem) {
		var policies_id = compass.generateId();

		var _drawContactDetailsInstruction = function() {
			if (!_settings.individualInfo) return d.span({ className : 'contactDetailsHelperText' }, ('Please enter the name of the primary guest staying in this room.'));
		};

		var _drawCreditCardTitle = function() {
			var _drawPaymentRequiredTitle = function() {
				if (_settings.paymentRequired) {
					var paymentRequiredTitleCopy = " Payment must be attached to this individual or the reservation will be cancelled.";
					var paymentRequiredTitle = d.span({ className : 'paymentRequiredCreditCardTitle' }, (paymentRequiredTitleCopy));
					return paymentRequiredTitle;
				}
			};

			var _drawCreditCardTitleCopy = function() {
				var _format = compass.util.dateFormatter('mm/dd/yyyy');
				var creditCardTitleCopy;

				var hasServiceFees = _.some(_settings.reservations, function(res) {
					return (res.stayRecap.serviceFeeAmount > 0);
				});

				var _renderChargeDate = function(){
					return _settings.chargingInfo.chargingToday ? " today" : " on " + _format(_settings.chargingInfo.chargingFirstDate);
				};
				if (hasServiceFees) {
					creditCardTitleCopy = "We need a credit card to hold your room. A Service &amp; Technology Fee will be charged today to cover the cost of managing your reservation. Review the hotel policies for additional information.";
				} else if (_settings.chargingInfo.hasCharging ) { /* there is charging, today or in the future. */
					creditCardTitleCopy = "A deposit is required to reserve your room. The card on file will be charged" + _renderChargeDate() + ". Review the hotel policies for additional information.";
				} else {  /* the typical just guarnatee type. */
					var isPaymentComplex = _.findWhere(_settings.paymentOptions.payMethods, {'is_credit_card': "N"});
					creditCardTitleCopy = (isPaymentComplex ? _settings.labels.needPayment : _settings.labels.needCreditCard);
				}

				return creditCardTitleCopy;
			};

			var creditCardTitle = [_drawCreditCardTitleCopy(), _settings.paymentRequired ? _drawPaymentRequiredTitle() : ""];
			return d.div({ className : 'creditCardTitle demographicTitle' }, creditCardTitle);
		};

		_form = d.form({ className: 'forms' },
			d.div({ className : 'personalInfoHeader'},
				d.h3({ className : 'personalInfoTitle', id: _ids.contact}, 'Contact Details')
			),
			_drawContactDetailsInstruction,
			d.fieldset({ className : 'personalInfoMain' }),
			d.fieldset({ className : 'passwordsMain' }),
			d.div({id: _ids.payment},
				d.div({ className : 'paymentHeader' },
					d.h3({ className : 'paymentTitle'}, _settings.labels.payment)
				),
				_drawCreditCardTitle,
				(_settings.paymentOptions.allowPaymentRequiredCancel === true ? d.a({className : 'cancelReservations','href':'javascript:;'}, 'Cancel reservations') : null )

			),
			d.fieldset(
				d.div({ className: 'payment' })
			),
			d.div({ className : 'endPaymentInfo' }),
			d.div({ className : 'roomRequestsHeader', id: _ids.requests },
				d.div({className : 'toggleIcon'}),
				d.h3({ className : 'roomRequestsTitle'},'Room Requests',
					d.span({ className : 'optionalSection'}, ' (optional)')
				),
				d.div({className : 'floatClear'})
			),
			d.fieldset({ className : 'roomRequestsMain' }),
			d.div({ className : 'frequentGuestNumberHolder'}),
			d.div({ className : 'roomSharesHeader' },
				d.div({ className : 'toggleIcon'}),
				d.div({className : 'roomSharesTitle', id: _ids.shares}, 'Room Shares'),
				d.div({className: 'clear'})
			),
			d.fieldset({className : 'roomSharesMain' }),
			d.h3(
				d.reader('Policies')
			),
			d.div({className : 'policiesAgreeDiv'},
				d.input({
					className : 'policiesCheckbox',
					type: 'checkbox',
					name: 'policiesCheckbox',
					'data-parsley-required': 'true',
					id: policies_id,
					'tabindex': '0',
					value: 'true'
				}),
				d.label({
					'for': policies_id
				},
					d.div({className: 'policiesTextDiv'}, 'By placing your booking with us, you agree to the '),
					d.reader('hotel policies'),
					d.a({ className: 'policiesLink', 'tabindex': '0', 'href': 'javascript:;', 'aria-owns': _ids.policies }, 'hotel policies'),
					_drawTermsOfService(),
					d.div({className: 'clear'})
				)
			),
			d.reader(d.input({ type: 'submit', 'tabindex': '-1' })),
			d.button({ className : 'finishButton button', 'tabindex': '0', role : 'button', 'ARIA-role' : 'button' }, 'Finish')
		);

		widgetElem.append(_form);
	    
		_form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			_submitPersonalInfoForm();
		});

		_form.find('.placeholder').attr('aria-hidden', 'true');

		_personalInfoWidget = new compass.demographic.PersonalInfoWidget(_form.find('.personalInfoMain'), {
			WUID : 'personalInfoWidget_individualPersonalInfo',
			drawAddress : false,
			prefill: _settings.individualInfo,
			drawCompanyName : true,
			extraRequiredFields: _settings.extraRequiredFields,
			editablePrefill: _settings.editablePrefill
		});

		if (!_settings.individualInfo) {
			_passwordWidget = new compass.demographic.PasswordWidget(_form.find('.passwordsMain'), {
				WUID : 'passwordWidget_individualPersonalInfo'
			});
		}

		_frequentGuestNumberWidget = new compass.demographic.FrequentGuestNumberWidget(_form.find('.frequentGuestNumberHolder'), {
			WUID : 'frequentGuestNumber_individualPersonalInfo',
			frequentGuestNumber : null
		});

		_paymentWidget = new compass.demographic.PaymentWidget(_form.find('.payment'), {
			WUID : 'creditCardWidget_individualPersonalInfo',
			addressWidget : {
				countries : _settings.countriesAndStates.countries,
				states : _settings.countriesAndStates.states,
				countriesWithStates : _settings.countriesAndStates.countriesWithStates
			},
			creditCardTypes : _settings.paymentOptions.payMethods,
			minExpiration: compass.util.parse.ISODateParser(_settings.reservations[0].stayRecap.checkOut),
			displayCVC: _settings.paymentOptions.storeCvc,
			storedPayments: (_settings.individualInfo && _settings.individualInfo.payments.length > 0 ) ? _settings.individualInfo.payments : false,
			currentPayment: (_settings.individualInfo) ? _settings.individualInfo.payments[0] : false,
			maskCCNumber : _.contains(_settings.extraRequiredFields, 'maskCreditCard'),
			payMethods: _settings.paymentOptions.payMethods
		});	
	
		// warning: the AddressWidget removes some parsley constraints. In order for that to work
		// the form needs to be parsley'ized so we're doing this as soon as all the form elements are created 
		_form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

 		_form.parsley().on('form:error', function() {
 			_invalid = true;
 			return;
 		});

		_form.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		_form.parsley().on('field:validated', function(elem) {
			if (_invalid) { _checkWholeForm(); }
		});

		if ( _settings.individualInfo && _settings.individualInfo.address) {
			//Checks to see if value inside address is not empty
			if(_settings.individualInfo.address.address1 !== '') {
				var addressObj = _settings.individualInfo.address;
				addressObj.postalCode = addressObj.postal_code;
				var aw = _paymentWidget.getAddressWidgetJSObject();
				if(aw) {
					aw.setAddress(addressObj);
				}
			}
		}

		// HACK: python side does not supports multiple reservations, this should be fine
		_roomRequestsWidget = new compass.hotel.RoomRequestsWidget(_form.find('.roomRequestsMain'), {
			WUID : 'roomRequestsWidget_individualPersonalInfo',
			collapsable : true,
			roomRequestOptions : _settings.commonRequests.requests,
			accessibilityOptions : _settings.commonRequests.accessibilityRequests,
			showExtraNotes : _settings.commonRequests.showExtraNotes,
			showADAOptions : _settings.commonRequests.showADAOptions,
			notes : _settings.commonRequests.notes
		});

		var shares = 0;
		var roomShareInfo = [];
		for(var res=0; res<_settings.reservations.length; res++) {
			if ( (_settings.reservations[res].stayRecap.occupancy - 1) > shares) {
				shares =  _settings.reservations[res].stayRecap.occupancy - 1;
			}
			if(_settings.reservations[res].reservation && _settings.reservations[res].reservation.shares) {
				for(var roomShare = 0; roomShare < _settings.reservations[res].reservation.shares.length; roomShare++) {
					roomShareInfo.push(_settings.reservations[res].reservation.shares[roomShare]);
				}
			}
		}
		if(shares > 0 ) {
			_roomSharesWidget = new compass.hotel.RoomSharesWidget(_form.find('.roomSharesMain'), {
				WUID : 'roomSharesWidget_individualPersonalInfo',
				collapsable : true,
				numberOfShares : shares,
				roomShareInfo: roomShareInfo
			});
		}
		else {
			_form.find('.roomSharesHeader').hide();
			_form.find('.roomSharesMain').hide();
		}

		_form.find(".stayRecapMain").append(d.div({className : 'stayRecapShadow'}));

	};

	var _submitPersonalInfoForm = function() {
		var button = _form.find(".finishButton");
		if(button.hasClass('disabled')) {
			return;
		}
		button.addClass('disabled').attr('tabindex', '-1');
		widgetArray = [_personalInfoWidget, _passwordWidget,_paymentWidget,_roomRequestsWidget];


		formData = {};

		formData['policiesCheckbox'] = $j('.policiesCheckbox').prop('checked');
		if(formData['policiesCheckbox'] === false){
			_policiesAgreeDialog = d.alert("Please agree to your hotel's policies before continuing.");
		}

		jQuery.map(widgetArray, function(widget){
			if (widget) {
				formData[widget.getWidgetName()] = widget.grabValues();
			}
		});

		_addParsleyToCreditCardWidget();

		_form.parsley().validate();

 		if (_invalid) {
 			return;
 		}


		if(_roomSharesWidget){
			formData[_roomSharesWidget.getWidgetName()] = _roomSharesWidget.grabValues();
		} else {
			formData["RoomSharesWidget"] = [];
		}

		formData['frequentGuestNumberWidget'] = _frequentGuestNumberWidget.grabValues();

		compass.loading.start(button.empty(), { color : '#FFFFFF' });

		var finishLoading = function() {
			compass.loading.stop();
			button.empty().append('Finish');
		};

		// call passed in submit function
		_settings.onFormSubmit(formData, finishLoading);
	};

	var _addParsleyToCreditCardWidget = function() {
		// credit card widget is variable and thus not parsleyized when this widget is initialized
		var _isCreditCard = _form.find('.creditCard').length > 0;

		if (_isCreditCard) {
			_form.parsley('addItem', '.cardNumberInput');
			_form.parsley('addItem', '.expMonth');
			_form.parsley('addItem', '.expYear');
			_form.parsley('addItem', '.input.nameOnCard');
			_form.parsley('addItem', '.address1Input');
			_form.parsley('addItem', '.cityInput');
			_form.parsley('addItem', '.stateSelect');
			_form.parsley('addItem', '.postalCodeInput');
		} else {
			_form.parsley('addItem', '.paymentSelect');
		}
	};

	var _checkWholeForm = function() {
		if (_form.find('.invalid').length <= 1) {
			_invalid = false;
			var button = _form.find(".finishButton");
			button.removeClass('disabled').attr('tabindex', '0');
		}
	};
	
	var getReservationData = this.getReservationData = function() {		
		if(_settings.reservations.length > 0) {
			return {
				"iterations": 1, //This gets modified by personalInfo, but is declared here to clarify where this variable belongs
				"reservations": _.map(_settings.reservations, function(res) { 
					return {
						"blocked_room_id": _settings.blockedRoomId[0],
						"arrive": res.stayRecap.checkIn,
						"depart": res.stayRecap.checkOut,
						"rooms": res.stayRecap.numRooms
					};
				})
			};
		} else {
			return {};
		}
	};

}, {
	WUID : 'CRAP',
	widgetName : 'IndividualFormsWidget',
	blockedRoomId : [],
	commonRequests : {},
	countriesAndStates : {},
	extraRequiredFields : [],
	individualInfo : {},
	paymentOptions : {},
	reservations : [],
	validIndividualHousing : false,
	onFormSubmit : function() {},
	ids: {},
	paymentRequired : false,
	labels: {
		payment: "Payment",
		needCreditCard: "We need a credit card to hold your room. Don't worry, we won't charge it today. Review the hotel policies for additional information.",
		needPayment: "We need a form of payment to hold your room. Don't worry, we won't charge it today. Review the hotel policies for additional information.",
		delayedChargingAndSetDate: "A deposit is required to reserve your rooms. The card on file will be charged. Review the hotel policies for additional information.",
		noDelayedChargingOrChargingDatePassed: "A deposit is required to reserve your rooms. Review the hotel policies for additional information."
	}
});
